import { useCallback } from 'react';

import { startOver } from '../../utils/api';

import './StartOver.css';

function StartOver({ handleError, handleStartOver }) {
  const handleConfirm = useCallback(async () => {
    try {
      await startOver();
    } catch (e) {
      handleError(e);
    }
  }, [handleError]);

  return (
    <div id="start-over-container" className="popup-overlay">
      <div className="popup">
        <div className="popup-title">Are you sure?</div>
        <p>This will clear your profile and your conversations.</p>
        <div className="actions">
          <div className="action action-secondary" onClick={handleStartOver}>Never mind</div>
          <div className="action action-primary" onClick={handleConfirm}>Yes, start over</div>
        </div>
      </div>
    </div>
  );
}

export default StartOver;